<template>
  <b-modal hide-footer centered content-class="custom-modal" v-model="show" no-close-on-backdrop 
      no-close-on-esc
      @hide="$emit('closed')"
      >
    <div class="error-verification-box">
        <div class="error-icon-modal">
          <i class="fas fa-exclamation-circle"></i>
        </div>
      <h3 class="error-verification-header">{{ t("errorModal.oops") }}</h3>
      <p class="error-verification-description">
        {{ message }}
      </p>
    </div>
  </b-modal>
</template>
<script lang="ts" setup>
import { defineProps,defineEmits, computed } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
interface Props {
  modelValue: boolean;
  message: string;
}
const props = defineProps<Props>();
const emit = defineEmits(["update:modelValue", "closed"]);

const show = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});
</script>
<script lang="ts">
export default {
  name: "ErrorModal",
};
</script>
<style>
.modal-header{
    border-bottom: none !important;
}
.error-verification-box {
  background: white;
  border-radius: 12px;
  /* shadow like modal */
  text-align: center; 
  width: 100%;
}
.error-verification-header {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
  font-family: Arial, Helvetica, sans-serif;
}
.error-icon-modal {
  font-size: 40px;
  color:#cf1616;
  margin-bottom: 15px;
}
.error-verification-description {
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
  font-family: Arial, Helvetica, sans-serif;
}
</style>